import { RootState } from 'src/ui/app/store';

export const loggedInUserEmail = (state: RootState) =>
  state.ui.loggedinUserEmail;
